// all game entities (other than the player) such as characters, etc. can be declared here
export const CHARACTERS = {
  testCharacter: {
    prototypeId: 'testCharacter',
    name: 'Test Character',
    spriteId: 'testCharacter'
  },
  elena: {
    prototypeId: 'elena',
    name: 'Captain Elena Solara',
    spriteId: 'elena'
  },
  kael: {
    prototypeId: 'kael',
    name: 'Commander Kael Rhyder',
    spriteId: 'kael'
  },
  zara: {
    prototypeId: 'zara',
    name: 'Commander Zara Lee',
    spriteId: 'zara'
  },
  nyx: {
    prototypeId: 'nyx',
    name: 'Captain Nyx',
    spriteId: 'nyx'
  },
  orion: {
    prototypeId: 'orion',
    name: 'Orion',
    spriteId: 'orion'
  }
}

export const LOCATIONS = {
  commandCenter: {
    name: 'Command Center',
    spriteId: 'commandCenter'
  },
  asteroidBase: {
    name: 'Asteroid Base',
    spriteId: 'asteroidBase'
  },
  weaponControlRoom: {
    name: 'Weapon Control Room',
    spriteId: 'weaponControlRoom'
  },
  nyxQuarters: {
    name: 'Nyx\'s Quarters',
    spriteId: 'nyxQuarters'
  },
  elenasQuarters: {
    name: 'Elena\'s Quarters',
    spriteId: 'elenasQuarters'
  },
  conflictPlanet: {
    name: 'Conflict Planet',
    spriteId: 'conflictPlanet'
  },
  negotiationRoom: {
    name: 'Negotiation Room',
    spriteId: 'negotiationRoom'
  },
  starryView: {
    name: 'Starry View',
    spriteId: 'starryView'
  },
  starshipBridge: {
    name: 'Starship Bridge',
    spriteId: 'starshipBridge'
  }
}
